import React, { useEffect, createElement } from 'react';
import { useLocation } from 'react-router-dom';
const PIXEL_ID = '1413548533871491';
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}
export function Analytics() {
  const location = useLocation();
  // Inject the Meta Pixel via an inline <script> tag (the snippet's own IIFE
  // can safely find script tags in the DOM since the inline script itself
  // is appended to <head> before it executes).
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (window.fbq) return;
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
  }, []);
  // Track PageView on every SPA route change
  useEffect(() => {
    try {
      window.fbq?.('track', 'PageView');
    } catch {
      /* ignore */
    }
  }, [location.pathname]);
  return <noscript data-id="element-10">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-11" />
    </noscript>;
}